import { useState, useRef, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { apiRequest } from '../services/api';

// ── Excel şablonu indir ───────────────────────────────────────────────────────
function sablonIndir() {
  const cols = [
    { key: 'SatirNo',      label: 'Satır No',        width: 10, aciklama: 'Zorunlu · Sıra numarası (1, 2, 3…)' },
    { key: 'TcPasaportNo', label: 'TC / Pasaport No', width: 20, aciklama: 'Opsiyonel · TC kimlik (11 hane) veya pasaport numarası' },
    { key: 'Ad',           label: 'Ad',               width: 14, aciklama: 'Zorunlu · Misafirin adı' },
    { key: 'Soyad',        label: 'Soyad',            width: 14, aciklama: 'Zorunlu · Misafirin soyadı' },
    { key: 'Cinsiyet',     label: 'Cinsiyet',         width: 12, aciklama: 'Opsiyonel · Erkek veya Kadın' },
    { key: 'DogumTarihi',  label: 'Doğum Tarihi',     width: 16, aciklama: 'Opsiyonel · gg.AA.yyyy formatında (örn: 01.01.1985)' },
    { key: 'Uyruk',        label: 'Uyruk',            width: 12, aciklama: 'Opsiyonel · Türk, Alman, vb. — boş bırakılırsa "Türk" atanır' },
    { key: 'Ulke',         label: 'Ülke',             width: 16, aciklama: 'Opsiyonel · Ülke adı (örn: TÜRKİYE, ALMANYA, RUSYA). KBS/yabancı misafir kaydı için önemlidir.' },
    { key: 'Telefon',      label: 'Telefon',          width: 16, aciklama: 'Opsiyonel · Telefon numarası' },
    { key: 'OdaNo',        label: 'Oda No',           width: 10, aciklama: 'Zorunlu · Sistemdeki oda numarasıyla tam eşleşmeli (örn: 101)' },
    { key: 'GirisTarihi',  label: 'Giriş Tarihi',     width: 16, aciklama: 'Zorunlu · gg.AA.yyyy formatında (örn: 25.04.2026)' },
    { key: 'GirisSaati',   label: 'Giriş Saati',      width: 14, aciklama: 'Opsiyonel · SS:dd formatında — boş bırakılırsa 14:00 atanır' },
    { key: 'CikisTarihi',  label: 'Çıkış Tarihi',     width: 16, aciklama: 'Opsiyonel · gg.AA.yyyy veya "BELİRSİZ" — boş bırakılırsa belirsiz sayılır' },
    { key: 'CikisSaati',   label: 'Çıkış Saati',      width: 14, aciklama: 'Opsiyonel · SS:dd formatında — boş bırakılırsa 12:00 atanır' },
    { key: 'KisiSayisi',   label: 'Kişi Sayısı',      width: 12, aciklama: 'Opsiyonel · Odadaki misafir sayısı.\nKişi bazlı ve kademeli fiyatlandırma için önemlidir.\nBoş bırakılırsa 1 kabul edilir.' },
    { key: 'OdaTutari',    label: 'Oda Tutarı (₺)',   width: 16, aciklama: 'Opsiyonel · Elle tutar girilirse firma fiyat kuralı hesaplanmaz, bu değer kullanılır.' },
    { key: 'AcenteAd',     label: 'Acente Adı',       width: 18, aciklama: 'Opsiyonel · Sistemdeki acente adıyla tam eşleşmeli.' },
    { key: 'FirmaAd',      label: 'Firma Adı',        width: 18, aciklama: 'Opsiyonel · Sistemdeki firma adıyla tam eşleşmeli.\nFirma girilirse Fiyat Tipi sütununa göre ücret otomatik hesaplanır.' },
    { key: 'FiyatTipi',    label: 'Fiyat Tipi',       width: 16, aciklama: 'Opsiyonel · Firma fiyat tipi. Geçerli değerler:\n  Gecelik    → Odaya sabit gecelik ücret (kişi sayısından bağımsız)\n  Kişi bazlı → Kişi başı sabit fiyat × kişi sayısı\n  Kademeli   → Her kişi pozisyonu farklı fiyat\nBoş bırakılırsa sırasıyla Gecelik → Kişi bazlı → Kademeli denenir.' },
    { key: 'BelirsizKilitle', label: 'Odayı Kilitle (Gün)', width: 20, aciklama: 'Opsiyonel · Belirsiz çıkışlı rezervasyonlarda odayı kaç gün kilitleyeceğini belirtir. Boş bırakılırsa kilitleme yapılmaz.' },
    { key: 'Aciklama',     label: 'Açıklama',         width: 24, aciklama: 'Opsiyonel · Rezervasyon notu veya özel bilgi.' },
  ];

  const ornekler = [
    // SatırNo, TC, Ad, Soyad, Cinsiyet, Doğum, Uyruk, Ülke, Tel, Oda, Giriş, GirisSaat, Çıkış, ÇıkışSaat, Kişi, Tutar, Acente, Firma, FiyatTipi, Açıklama
    [1, '12345678901', 'Ali',    'Yılmaz', 'Erkek', '15.06.1980', 'Türk',  'TÜRKİYE',  '5551112233', '101', '25.04.2026', '14:00', '28.04.2026', '12:00', 1, 1500,  '',          '',          'Gecelik',    'VIP misafir'],
    [2, 'A12345678',  'Maria',  'Schmidt', 'Kadın', '20.03.1990', 'Alman', 'ALMANYA',   '',           '102', '25.04.2026', '14:00', 'BELİRSİZ',  '12:00', 2, 0,     '',          'BMW Grubu', 'Kişi bazlı', ''],
    [3, '',           'Mehmet', 'Demir',   'Erkek', '',           'Türk',  'TÜRKİYE',   '5559876543', '103', '26.04.2026', '14:00', '30.04.2026', '12:00', 3, 0,     'SunTravel', '',          'Kademeli',   ''],
  ];

  const ws = XLSX.utils.aoa_to_sheet([
    cols.map(c => c.label),
    ...ornekler,
    [],
    ['— AÇIKLAMALAR —'],
    ...cols.map(c => [c.label, c.aciklama]),
  ]);

  // Sütun genişlikleri
  ws['!cols'] = cols.map(c => ({ wch: c.width }));

  // Başlık satırı stili
  const headerStyle = {
    fill: { fgColor: { rgb: '4F46E5' } },
    font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    border: {
      top: { style: 'thin', color: { rgb: 'FFFFFF' } },
      bottom: { style: 'thin', color: { rgb: 'FFFFFF' } },
      left: { style: 'thin', color: { rgb: 'FFFFFF' } },
      right: { style: 'thin', color: { rgb: 'FFFFFF' } },
    }
  };
  // Zorunlu sütun başlıkları
  const zorunluStyle = { ...headerStyle, fill: { fgColor: { rgb: '7C3AED' } } };
  const zorunluKolonlar = new Set(['SatirNo', 'Ad', 'Soyad', 'OdaNo', 'GirisTarihi']);

  cols.forEach((c, i) => {
    const addr = XLSX.utils.encode_cell({ r: 0, c: i });
    if (!ws[addr]) ws[addr] = { v: c.label, t: 's' };
    ws[addr].s = zorunluKolonlar.has(c.key) ? zorunluStyle : headerStyle;
    ws[addr].c = [{ a: 'HotelFlow', t: c.aciklama }];
  });

  // Örnek satır stilleri
  const evenStyle = { fill: { fgColor: { rgb: 'EEF2FF' } }, font: { sz: 10 }, alignment: { vertical: 'center' } };
  const oddStyle  = { fill: { fgColor: { rgb: 'FFFFFF' } }, font: { sz: 10 }, alignment: { vertical: 'center' } };
  ornekler.forEach((row, ri) => {
    row.forEach((_, ci) => {
      const addr = XLSX.utils.encode_cell({ r: ri + 1, c: ci });
      if (!ws[addr]) ws[addr] = { v: '', t: 's' };
      ws[addr].s = ri % 2 === 0 ? evenStyle : oddStyle;
    });
  });

  // Satır yüksekliği
  ws['!rows'] = [{ hpt: 28 }, { hpt: 20 }, { hpt: 20 }, { hpt: 20 }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Rezervasyonlar');
  XLSX.writeFile(wb, 'toplu_import_sablon.xlsx');
}

// ── Excel tarih parse ─────────────────────────────────────────────────────────
function pad2(n) { return String(n).padStart(2, '0'); }

function excelTarihStr(val) {
  if (!val && val !== 0) return '';
  if (typeof val === 'number') {
    const d = XLSX.SSF.parse_date_code(val);
    if (!d) return '';
    return `${pad2(d.d)}.${pad2(d.m)}.${d.y}`;
  }
  const s = String(val).trim();
  // dd.MM.yyyy veya dd/MM/yyyy
  if (/^\d{1,2}[./]\d{1,2}[./]\d{4}$/.test(s)) {
    const parts = s.split(/[./]/);
    return `${pad2(parts[0])}.${pad2(parts[1])}.${parts[2]}`;
  }
  // yyyy-MM-dd
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) {
    const parts = s.slice(0, 10).split('-');
    return `${parts[2]}.${parts[1]}.${parts[0]}`;
  }
  return s;
}

function excelSaatStr(val) {
  if (!val && val !== 0) return '';
  if (typeof val === 'number') {
    const d = XLSX.SSF.parse_date_code(val);
    if (!d) return '';
    return `${pad2(d.H || 0)}:${pad2(d.M || 0)}`;
  }
  const s = String(val).trim();
  if (/^\d{1,2}:\d{2}/.test(s)) return s.slice(0, 5);
  return '';
}

// ── Satır parse ───────────────────────────────────────────────────────────────
function parseRows(ws) {
  const rows = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true, defval: '' });
  if (rows.length < 2) return [];
  const header = rows[0].map(c => String(c).trim());

  // Türkçe karakter + boşluk + özel sembol normalize → başlık eşleşmesi
  const norm = s => String(s).toLowerCase()
    .replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ı/g, 'i')
    .replace(/ö/g, 'o').replace(/ş/g, 's').replace(/ü/g, 'u')
    .replace(/[^a-z0-9]/g, '');

  const col = name => {
    const n = norm(name);
    return header.findIndex(h => norm(h) === n);
  };

  const get = (row, name) => {
    const i = col(name);
    return i >= 0 ? row[i] : '';
  };

  const parsed = [];
  for (let i = 1; i < rows.length; i++) {
    const r = rows[i];
    const ad = String(get(r, 'Ad') || '').trim();
    const soyad = String(get(r, 'Soyad') || '').trim();
    if (!ad && !soyad) continue;

    const cikisRaw = get(r, 'CikisTarihi');
    const cikisStr = excelTarihStr(cikisRaw) || String(cikisRaw || '').trim().toUpperCase();

    parsed.push({
      satırNo: i,
      tcPasaportNo: String(get(r, 'TcPasaportNo') || '').trim(),
      ad,
      soyad,
      cinsiyet: String(get(r, 'Cinsiyet') || '').trim(),
      dogumTarihi: excelTarihStr(get(r, 'DogumTarihi')),
      uyruk: String(get(r, 'Uyruk') || '').trim(),
      ulke: String(get(r, 'Ülke') || '').trim(),
      telefon: String(get(r, 'Telefon') || '').trim(),
      odaNo: String(get(r, 'OdaNo') || '').trim(),
      girisTarihi: excelTarihStr(get(r, 'GirisTarihi')),
      girisSaati: excelSaatStr(get(r, 'GirisSaati')) || '14:00',
      cikisTarihi: cikisStr || 'BELİRSİZ',
      cikisSaati: excelSaatStr(get(r, 'CikisSaati')) || '12:00',
      kisiSayisi: parseInt(String(get(r, 'Kişi Sayısı') || '').trim()) || 1,
      odaTutari: parseFloat(String(get(r, 'OdaTutari') || '').replace(',', '.')) || null,
      acenteAd: String(get(r, 'Acente Adı') || '').trim(),
      firmaAd: String(get(r, 'Firma Adı') || '').trim(),
      fiyatTipi: String(get(r, 'Fiyat Tipi') || '').trim(),
      belirsizKilitle: parseInt(String(get(r, 'Odayı Kilitle (Gün)') || '').trim()) || null,
      aciklama: String(get(r, 'Aciklama') || '').trim(),
    });
  }
  return parsed;
}

// ─────────────────────────────────────────────────────────────────────────────
export default function TopluImportModal({ onClose, onTamamlandi }) {
  const [satirlar, setSatirlar] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [sonuclar, setSonuclar] = useState(null);
  const [firmalar, setFirmalar] = useState([]);
  const [secilenFirmaAd, setSecilenFirmaAd] = useState('');
  const fileRef = useRef();

  useEffect(function () {
    document.body.style.overflow = 'hidden';
    apiRequest('dbfix/firmalar', 'GET').then(function (data) {
      if (Array.isArray(data)) setFirmalar(data);
    }).catch(function () {});
    return function () { document.body.style.overflow = 'unset'; };
  }, []);

  function dosyaSec(e) {
    const file = e.target.files[0];
    if (!file) return;
    setSonuclar(null);
    const reader = new FileReader();
    reader.onload = function (ev) {
      try {
        const data = new Uint8Array(ev.target.result);
        const wb = XLSX.read(data, { type: 'array' });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = parseRows(ws);
        if (rows.length === 0) { alert('Dosyada geçerli satır bulunamadı. Lütfen şablonu kullanın.'); return; }
        setSatirlar(rows);
      } catch (err) {
        alert('Dosya okunamadı: ' + err.message);
      }
    };
    reader.readAsArrayBuffer(file);
    e.target.value = '';
  }

  async function importYap() {
    if (!satirlar || satirlar.length === 0) return;
    setYukleniyor(true);
    setSonuclar(null);
    try {
      const payload = satirlar.map((s, idx) => ({
        satirNo: idx + 1,
        tcPasaportNo: s.tcPasaportNo || null,
        ad: s.ad,
        soyad: s.soyad,
        cinsiyet: s.cinsiyet || null,
        dogumTarihi: s.dogumTarihi || null,
        uyruk: s.uyruk || null,
        ulke: s.ulke || null,
        telefon: s.telefon || null,
        odaNo: s.odaNo,
        girisTarihi: s.girisTarihi,
        girisSaati: s.girisSaati,
        cikisTarihi: s.cikisTarihi,
        cikisSaati: s.cikisSaati,
        kisiSayisi: s.kisiSayisi || 1,
        odaTutari: s.odaTutari ?? null,
        acenteAd: s.acenteAd || null,
        firmaAd: s.firmaAd || secilenFirmaAd || null,
        fiyatTipi: s.fiyatTipi || null,
        belirsizKilitle: s.belirsizKilitle || null,
        aciklama: s.aciklama || null,
      }));
      const sonuc = await apiRequest('rezervasyonlar/toplu-import', 'POST', payload);
      setSonuclar(sonuc);
      if (onTamamlandi) onTamamlandi();
    } catch (err) {
      alert('Import hatası: ' + err.message);
    } finally {
      setYukleniyor(false);
    }
  }

  const basarili = (sonuclar || []).filter(s => s.basarili).length;
  const hatali = (sonuclar || []).filter(s => !s.basarili).length;

  return (
    <div
      className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[9000] flex items-center justify-center p-4"
      onClick={function (e) { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-5xl max-h-[92vh] flex flex-col overflow-hidden">

        {/* Başlık */}
        <div className="bg-gradient-to-r from-indigo-600 to-violet-600 px-8 py-6 flex items-center justify-between flex-shrink-0">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-white/10 rounded-2xl flex items-center justify-center text-2xl shadow-inner">📋</div>
            <div>
              <h2 className="text-xl font-black text-white tracking-tight leading-none">Toplu Rezervasyon İmport</h2>
              <p className="text-white/60 text-[10px] font-black uppercase tracking-widest mt-1.5">Excel dosyasından toplu aktarım</p>
            </div>
          </div>
          <button onClick={onClose} className="w-10 h-10 bg-white/10 hover:bg-white/20 text-white rounded-xl flex items-center justify-center font-black text-lg transition-all">✕</button>
        </div>

        <div className="flex flex-col gap-5 overflow-y-auto p-8 flex-1 custom-scrollbar">

          {/* Firma seçici */}
          {firmalar.length > 0 && (
            <div className="flex flex-col gap-1.5">
              <label className="text-[9px] font-black text-slate-400 uppercase tracking-widest pl-1">Firma (Tüm Import İçin — Opsiyonel)</label>
              <select
                value={secilenFirmaAd}
                onChange={function (e) { setSecilenFirmaAd(e.target.value); }}
                className="h-12 px-4 rounded-2xl border-2 border-slate-200 focus:border-indigo-400 focus:outline-none text-sm font-bold text-slate-700 bg-white"
              >
                <option value="">— Firma seçme (Excel'deki değer kullanılır) —</option>
                {firmalar.map(function (f) {
                  return <option key={f.firmaId} value={f.ad}>{f.ad}</option>;
                })}
              </select>
              {secilenFirmaAd && (
                <p className="text-[9px] font-black text-indigo-500 pl-1 uppercase tracking-widest">✓ Tüm satırlara "{secilenFirmaAd}" firması atanacak</p>
              )}
            </div>
          )}

          {/* Şablon + Yükle */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={sablonIndir}
              className="flex-1 flex items-center justify-center gap-3 h-16 bg-slate-50 hover:bg-slate-100 border-2 border-slate-200 hover:border-indigo-300 rounded-2xl text-[11px] font-black text-slate-600 uppercase tracking-widest transition-all active:scale-[0.98]"
            >
              <span className="text-xl">⬇️</span> Şablon İndir (.xlsx)
            </button>
            <button
              onClick={function () { fileRef.current.click(); }}
              className="flex-1 flex items-center justify-center gap-3 h-16 bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 rounded-2xl text-[11px] font-black text-white uppercase tracking-widest shadow-lg shadow-indigo-200 transition-all active:scale-[0.98]"
            >
              <span className="text-xl">📂</span>
              {satirlar ? `${satirlar.length} Satır Yüklendi — Değiştir` : 'Excel Dosyası Seç'}
            </button>
            <input ref={fileRef} type="file" accept=".xls,.xlsx" className="hidden" onChange={dosyaSec} />
          </div>

          {/* Ön izleme tablosu */}
          {satirlar && !sonuclar && (
            <div className="flex flex-col gap-3">
              <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest pl-1">{satirlar.length} satır okundu — önizleme</p>
              <div className="border-2 border-slate-100 rounded-2xl overflow-hidden max-h-72 overflow-y-auto custom-scrollbar">
                <table className="w-full text-[11px]">
                  <thead className="bg-slate-50 border-b border-slate-100 sticky top-0">
                    <tr>
                      {['#', 'Ad Soyad', 'TC/Pasaport', 'Oda', 'Giriş', 'Çıkış', 'Kişi', 'Tutar', 'Fiyat Tipi', 'Firma/Acente'].map(h => (
                        <th key={h} className="px-3 py-2.5 text-left text-[9px] font-black text-slate-400 uppercase tracking-widest whitespace-nowrap">{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-50">
                    {satirlar.map(function (s, i) {
                      return (
                        <tr key={i} className="hover:bg-slate-50 transition-colors">
                          <td className="px-3 py-2 text-slate-400 font-black">{i + 1}</td>
                          <td className="px-3 py-2 font-bold text-slate-700 whitespace-nowrap">{s.ad} {s.soyad}</td>
                          <td className="px-3 py-2 text-slate-500 font-mono">{s.tcPasaportNo || '—'}</td>
                          <td className="px-3 py-2 font-black text-indigo-600">{s.odaNo || '—'}</td>
                          <td className="px-3 py-2 text-slate-600 whitespace-nowrap">{s.girisTarihi || '—'}</td>
                          <td className="px-3 py-2 text-slate-600 whitespace-nowrap">{s.cikisTarihi === 'BELİRSİZ' ? <span className="text-amber-500">Belirsiz</span> : s.cikisTarihi || '—'}</td>
                          <td className="px-3 py-2 text-slate-500 text-center">{s.kisiSayisi}</td>
                          <td className="px-3 py-2 text-emerald-600 font-black whitespace-nowrap">{s.odaTutari != null ? `${Number(s.odaTutari).toLocaleString('tr-TR')} ₺` : '—'}</td>
                          <td className="px-3 py-2 text-slate-500 whitespace-nowrap">{s.fiyatTipi || '—'}</td>
                          <td className="px-3 py-2 text-slate-500 max-w-[120px] truncate">{s.firmaAd || s.acenteAd || '—'}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Sonuçlar tablosu */}
          {sonuclar && (
            <div className="flex flex-col gap-3">
              <div className={`flex items-center gap-4 px-5 py-4 rounded-2xl font-black text-sm ${hatali === 0 ? 'bg-emerald-50 text-emerald-700 border-2 border-emerald-100' : 'bg-amber-50 text-amber-700 border-2 border-amber-100'}`}>
                <span>✅ {basarili} rezervasyon oluşturuldu</span>
                {hatali > 0 && <span>· ⚠️ {hatali} satır hatalı</span>}
              </div>
              <div className="border-2 border-slate-100 rounded-2xl overflow-hidden max-h-72 overflow-y-auto custom-scrollbar">
                <table className="w-full text-[11px]">
                  <thead className="bg-slate-50 border-b border-slate-100 sticky top-0">
                    <tr>
                      {['#', 'Ad Soyad', 'Oda', 'Durum', 'Mesaj'].map(h => (
                        <th key={h} className="px-3 py-2.5 text-left text-[9px] font-black text-slate-400 uppercase tracking-widest">{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-50">
                    {sonuclar.map(function (s) {
                      return (
                        <tr key={s.satirNo} className={'hover:bg-slate-50 transition-colors ' + (s.basarili ? '' : 'bg-rose-50/40')}>
                          <td className="px-3 py-2 text-slate-400 font-black">{s.satirNo}</td>
                          <td className="px-3 py-2 font-bold text-slate-700 whitespace-nowrap">{s.adSoyad || '—'}</td>
                          <td className="px-3 py-2 font-black text-indigo-600">{s.odaNo || '—'}</td>
                          <td className="px-3 py-2">
                            {s.basarili
                              ? <span className="bg-emerald-100 text-emerald-700 px-2.5 py-1 rounded-xl text-[9px] font-black uppercase tracking-widest">Tamam</span>
                              : <span className="bg-rose-100 text-rose-600 px-2.5 py-1 rounded-xl text-[9px] font-black uppercase tracking-widest">Hata</span>}
                          </td>
                          <td className="px-3 py-2 text-slate-600 max-w-xs truncate" title={s.mesaj}>{s.mesaj}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>

        {/* Alt Butonlar */}
        <div className="px-8 py-5 border-t border-slate-100 flex items-center justify-between gap-3 flex-shrink-0 bg-slate-50/50 rounded-b-[2.5rem]">
          <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest hidden sm:block">
            {satirlar && !sonuclar ? `${satirlar.length} satır hazır` : sonuclar ? `${basarili} başarılı · ${hatali} hatalı` : 'Dosya bekleniyor'}
          </p>
          <div className="flex items-center gap-3 ml-auto">
            <button
              onClick={onClose}
              className="h-12 px-8 border-2 border-slate-200 text-slate-600 hover:bg-slate-100 font-black text-[10px] uppercase tracking-widest rounded-2xl transition-all active:scale-95"
            >
              {sonuclar ? 'Kapat' : 'İptal'}
            </button>
            {satirlar && !sonuclar && (
              <button
                onClick={importYap}
                disabled={yukleniyor}
                className="h-12 px-8 bg-gradient-to-r from-indigo-600 to-violet-600 hover:from-indigo-700 hover:to-violet-700 disabled:from-slate-300 disabled:to-slate-300 text-white font-black text-[10px] uppercase tracking-widest rounded-2xl shadow-lg shadow-indigo-200 transition-all active:scale-95 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {yukleniyor
                  ? <><span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin"></span> İçe Aktarılıyor...</>
                  : <><span>📤</span> {satirlar.length} Rezervasyon Oluştur</>}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
